import { GetAllocationDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

import { Expensable } from 'modules/expenses/types/Expensable'

export const useBudgets = (expensable?: Expensable) => {
  const budget = expensable?.bugdetMovement?.budget

  const { data, loading } = useQuery(GetAllocationDocument, {
    variables: {
      employeeIds: [String(expensable?.owner?.id)],
      budgetId: String(budget?.id),
      periodStart: budget?.currentPeriodStart,
    },
    skip: !budget?.id || !expensable?.owner?.id,
  })
  const budgetAllocation = data?.finance.budgetAllocationsConnection.nodes[0]

  return { budget, budgetAllocation, loading }
}
